import './IbanTermsClause.scss';
import React, { useEffect } from 'react';
import { recordIdentityEvent } from 'utilities/uTagging';
import { EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import { IDENTITY_CONST } from 'constants/uTagConstants/paths';
import CheckBox from 'components/checkBox/checkBox';
import { FormattedText } from 'core/i18n';
import PropTypes from 'prop-types';
import { AcceptTermsMessage } from '../../commons/acceptTermsMessage/AcceptTermsMessage';
import { formatText } from '../../../core/i18n';

const IbanTermsClause = ({ formActions: { change }, userProfile, userProfileForm, formActions }) => {
    useEffect(() => {
        change('userProfile.ibanTermsClause', false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleIbanClause = value => {
        change('userProfile.ibanTermsClause', value);

        value
            ? recordIdentityEvent(EVENT_ONBOARDING, IDENTITY_CONST, `aceptar condiciones iban`)
            : recordIdentityEvent(EVENT_ONBOARDING, 'errores formulario', `iban debes aceptar la clausula`);
    };

    return (
        <CheckBox
            profileModel="userProfile.ibanTermsClause"
            fieldsRequired="1"
            checkBoxList={[
                {
                    label: <FormattedText value="identify-ibanTermsClause" />,
                    model: 'userProfile.ibanTermsClause',
                    required: true,
                    onChange: handleIbanClause,
                    errorMessageComponent: (
                        <AcceptTermsMessage
                            text={formatText('validation-fieldRequiredDataProtectionClauseIdentification')}
                        />
                    ),
                },
            ]}
            userProfile={userProfile}
            userProfileForm={userProfileForm}
            formActions={formActions}
            noTag
            messagesError={{}}
        />
    );
};

IbanTermsClause.propTypes = {
    formActions: PropTypes.object,
    userProfile: PropTypes.object,
    userProfileForm: PropTypes.object,
};

export default IbanTermsClause;
